import { render } from "./EmdLogo.vue?vue&type=template&id=93379e9c"
import script from "./EmdLogo.vue?vue&type=script&lang=js"
export * from "./EmdLogo.vue?vue&type=script&lang=js"

import "./EmdLogo.vue?vue&type=style&index=0&id=93379e9c&lang=css"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/globals/EmdLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93379e9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93379e9c', __exports__)) {
    console.log('reload')
    api.reload('93379e9c', __exports__)
  }
  
  module.hot.accept("./EmdLogo.vue?vue&type=template&id=93379e9c", () => {
    console.log('re-render')
    api.rerender('93379e9c', render)
  })

}


export default __exports__